import React from 'react';
import { Box, Text, Center, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { getVersionInfo } from '../config/version';

interface VersionInfoProps {
  position?: 'sidebar' | 'footer';
}

const VersionInfo: React.FC<VersionInfoProps> = ({ position = 'sidebar' }) => {
  const versionInfo = getVersionInfo();
  const color = useColorModeValue('green.600', 'green.300');
  const hoverColor = useColorModeValue('green.800', 'green.100');

  const buildDate = new Date(versionInfo.buildTime).toLocaleDateString('es-AR', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  const tooltipContent = (
    <Box>
      <Text fontSize="sm" fontWeight="bold">{versionInfo.name}</Text>
      <Text fontSize="xs">Versión: {versionInfo.version}</Text>
      <Text fontSize="xs">Build: {buildDate}</Text>
    </Box>
  );

  const commonProps = {
    fontSize: 'xs',
    fontFamily: 'monospace',
    color: position === 'sidebar' ? 'green.300' : color,
    cursor: 'help',
    transition: 'all 0.2s ease',
    _hover: {
      color: position === 'sidebar' ? 'green.100' : hoverColor,
      transform: 'scale(1.05)'
    }
  };

  return (
    <Tooltip
      label={tooltipContent}
      placement="top"
      hasArrow
      bg="gray.800"
      color="white"
      fontSize="xs"
      borderRadius="md"
      p={2}
    >
      <Box 
        position={position === 'sidebar' ? 'absolute' : 'relative'}
        bottom={position === 'sidebar' ? 4 : 0}
        left={position === 'sidebar' ? 0 : undefined}
        right={position === 'sidebar' ? 0 : undefined}
        px={position === 'sidebar' ? 8 : 0}
      >
        <Center>
          <Text {...commonProps}>
            {versionInfo.fullVersion}
          </Text>
        </Center>
      </Box>
    </Tooltip>
  );
};

export default VersionInfo; 